export default {
  name: "gift"
};